import sortBy from 'lodash/sortBy';
import { ITag } from '../../types';
import { ISummaryIntakes, TagAction, TagType, TransactionStatus } from 'api-paths-cas';
import { SummaryState } from '../../store/student/summary/types';

interface PathwayProps {
  pathwayUniFullName?: string;
  isPathway?: boolean;
}

interface Props extends PathwayProps {
  tags: ITag[];
}

export const getAllTags = ({ tags, isPathway }: Props): ITag[] => {
  const filterTags =
    tags?.filter(
      tag =>
        (tag.type !== TagType.PROGRAMMABLE ||
          (tag.type === TagType.PROGRAMMABLE && tag.manualAction !== TagAction.REMOVE)) &&
        tag.manuallyRemoved !== true &&
        (tag.type !== TagType.TRANSFERMATE ||
          tag.paymentStatus === TransactionStatus.Paid ||
          tag.paymentStatus === TransactionStatus.Pending),
    ) ?? [];

  if (isPathway) {
    return filterTags.filter((tag: ITag) => tag.type !== TagType.PATHWAY);
  }

  return [...filterTags];
};

export const sortWIthIntakeFirst = (tags: ITag[]) => sortBy(tags, tag => (tag.type === TagType.MULTI_INTAKE ? 0 : 1));

export const createMultiIntakeTag = (
  summary: SummaryState,
): {
  type: TagType.MULTI_INTAKE;
  id: string;
  label: string;
  multiIntakeTagData: ISummaryIntakes[];
} => {
  return {
    type: TagType.MULTI_INTAKE,
    id: `${summary.intakeId}#${summary.offerId}`,
    label: 'Intake',
    multiIntakeTagData: summary.intakes!,
  };
};
